module.exports = __webpack_public_path__ + "static/media/encoding_google_cloud.322ae2de.svg";